__turbopack_context__.v({
  "answer": "AnswerQuestions-module-scss-module__wj6NBq__answer",
  "container": "AnswerQuestions-module-scss-module__wj6NBq__container",
  "content": "AnswerQuestions-module-scss-module__wj6NBq__content",
  "iconWrapper": "AnswerQuestions-module-scss-module__wj6NBq__iconWrapper",
  "item": "AnswerQuestions-module-scss-module__wj6NBq__item",
  "question": "AnswerQuestions-module-scss-module__wj6NBq__question",
  "question_active": "AnswerQuestions-module-scss-module__wj6NBq__question_active",
  "questionsWrapper": "AnswerQuestions-module-scss-module__wj6NBq__questionsWrapper",
});
